import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import versus from "./modules/versus";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 缓存组件
    cacheComponents: [],
  },
  mutations: {
    // 向缓存中添加组件
    ["ADD_COMPONENTS"](state, componentName) {
      if (state.cacheComponents.includes(componentName)) {
        return;
      }
      state.cacheComponents.push(componentName);
    },
    // 从缓存中移除组件
    ["REMOVE_COMPONENTS"](state, componentName) {
      const index = state.cacheComponents.indexOf(componentName);
      if (index === -1) {
        return;
      }
      state.cacheComponents.splice(index, 1);
    },
  },
  actions: {},
  modules: {
    user,
    versus,
  },
});
